var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrencyMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 3,
    y: 3,
    fill: "#fff",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3a6 6 0 0 0-6 6v26a6 6 0 0 0 6 6h26a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6H9Zm9.752 15.599c0 1.182.909 1.94 3.733 2.675 2.825.734 5.848 1.941 5.848 5.475 0 2.55-1.928 3.957-4.355 4.417v2.675h-3.733v-2.7c-2.389-.51-4.43-2.04-4.578-4.765h2.737c.137 1.468 1.145 2.612 3.708 2.612 2.75 0 3.36-1.368 3.36-2.227 0-1.157-.623-2.252-3.733-2.998-3.472-.834-5.849-2.265-5.849-5.14 0-2.4 1.942-3.968 4.355-4.491v-2.688h3.733v2.725c2.6.635 3.907 2.6 3.994 4.741h-2.75c-.074-1.555-.895-2.613-3.11-2.613-2.103 0-3.36.946-3.36 2.302Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyMobile);
export default __webpack_public_path__ + "static/media/currency_mobile.56d322002e0a53b3c3d27b215cf1bd03.svg";
export { ForwardRef as ReactComponent };